import axiosWithCredentials, { API_BASE_URL } from "@/libs/apis/commons";
import { FavoriteTokenRequestAction } from "nvs-types";

const postFavoritedApi = (
  chainId: string,
  contractAddress: string,
  tokenId: string,
) =>
  `${API_BASE_URL}/collections/${chainId}/${contractAddress}/${tokenId}/favorite`;

export const makeApiFavoritedCall = async (
  tokenId: string,
  chainId: number,
  contractAddress: string,
  action: FavoriteTokenRequestAction,
) => {
  return await axiosWithCredentials.post(
    postFavoritedApi(chainId.toString(), contractAddress, tokenId),
    {
      action,
    },
  );
};
